var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.styles)},_vm._l((_vm.columns),function(column,index){return _c('Column',{key:index,attrs:{"column-config":column}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }